export default __webpack_public_path__ + "AccentureLogoFooter.png";